
import React from 'react';
import { Language, t } from '../data/translations';

interface ConfirmDialogProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  language: Language;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ message, onConfirm, onCancel, language }) => {
  return (
    <div className="absolute inset-0 bg-black/70 flex items-center justify-center z-[200] animate-[fadeIn_0.2s_ease-out]">
      <div className="bg-slate-800 rounded-lg shadow-2xl p-8 text-center text-white border-2 border-slate-600 w-96">
        <h2 className="text-xl font-bold mb-4">{t('ui.areYouSure', language)}</h2>
        <p className="text-slate-300 mb-6">{message}</p>
        <div className="flex justify-center gap-4">
          <button
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-500 text-white font-bold py-2 px-6 rounded-lg transition-colors duration-300"
          >
            {t('ui.confirm', language)}
          </button>
          <button
            onClick={onCancel}
            className="bg-slate-600 hover:bg-slate-500 text-white font-bold py-2 px-6 rounded-lg transition-colors duration-300"
          >
            {t('ui.cancel', language)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
